import _extends from '@babel/runtime-corejs3/helpers/extends';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js/instance/map';
import React, { useState, useEffect, useMemo } from 'react';
import { getColor } from '../../tux-h5-color/dist/es/getColor.js';
import { useTUXContext } from '../TUXProvider/TUXProvider.js';
import { TUXSeparator } from '../TUXSeparator/TUXSeparator.js';
import { TUXNavBarBackAction } from './TUXNavBarBackAction.js';
import { TUXNavBarIconAction } from './TUXNavBarIconAction.js';
import { TUXNavBarTextAction } from './TUXNavBarTextAction.js';

var NavBarAction = function NavBarAction(props) {
  if (props.actionVariant === 'back') {
    return /*#__PURE__*/React.createElement(TUXNavBarBackAction, props);
  }

  if (props.actionVariant === 'icon') {
    return /*#__PURE__*/React.createElement(TUXNavBarIconAction, props);
  }

  if (props.actionVariant === 'text') {
    return /*#__PURE__*/React.createElement(TUXNavBarTextAction, props);
  }

  return null;
};

var _ref2 = /*#__PURE__*/React.createElement("div", {
  className: "absolute bottom-0 left-0 right-0"
}, /*#__PURE__*/React.createElement(TUXSeparator, {
  size: "medium",
  color: "LinePrimary"
}));

var TUXNavBar = function TUXNavBar(_ref) {
  var startActions = _ref.startActions,
      endActions = _ref.endActions,
      title = _ref.title,
      center = _ref.center,
      _ref$showSeparator = _ref.showSeparator,
      showSeparator = _ref$showSeparator === void 0 ? false : _ref$showSeparator,
      _ref$fixed = _ref.fixed,
      fixed = _ref$fixed === void 0 ? false : _ref$fixed,
      _ref$titleColor = _ref.titleColor,
      titleColor = _ref$titleColor === void 0 ? 'TextPrimary' : _ref$titleColor,
      titleOpacity = _ref.titleOpacity,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? 'BGPrimary' : _ref$backgroundColor,
      backgroundOpacity = _ref.backgroundOpacity;

  var _useTUXContext = useTUXContext(),
      theme = _useTUXContext.theme,
      navBarHeight = _useTUXContext.navBarHeight; // sometimes we don't know what theme it is during SSR
  // so we get the correct themed color in useEffect hook which doesn't run during SSR


  var _useState = useState(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      backgroundColorVal = _useState2[0],
      setBackgroundColorVal = _useState2[1];

  var _useState3 = useState(undefined),
      _useState4 = _slicedToArray(_useState3, 2),
      titleColorVal = _useState4[0],
      setTitleColorVal = _useState4[1];

  useEffect(function () {
    if (theme) {
      setBackgroundColorVal(getColor(backgroundColor, theme).rgba);
      setTitleColorVal(getColor(titleColor, theme).rgba);
    }
  }, [theme, backgroundColor, titleColor]);
  var start = useMemo(function () {
    if (!startActions) {
      return null;
    }

    if (Array.isArray(startActions)) {
      return _mapInstanceProperty(startActions).call(startActions, function (props, idx) {
        return /*#__PURE__*/React.createElement(NavBarAction, _extends({
          key: idx
        }, props));
      });
    } else {
      return /*#__PURE__*/React.createElement(NavBarAction, startActions);
    }
  }, [startActions]);
  var end = useMemo(function () {
    if (!endActions) {
      return null;
    }

    if (Array.isArray(endActions)) {
      return _mapInstanceProperty(endActions).call(endActions, function (props, idx) {
        return /*#__PURE__*/React.createElement(NavBarAction, _extends({
          key: idx
        }, props));
      });
    } else {
      return /*#__PURE__*/React.createElement(NavBarAction, endActions);
    }
  }, [endActions]);
  return /*#__PURE__*/React.createElement("div", {
    className: "TUXNavBar"
  }, /*#__PURE__*/React.createElement("div", {
    className: 'box-border top-0 left-0 right-0' + (fixed ? " fixed z-1000" : "")
  }, /*#__PURE__*/React.createElement("header", {
    className: "flex items-center px-8 overflow-hidden relative",
    style: {
      height: navBarHeight
    },
    role: "navigation"
  }, /*#__PURE__*/React.createElement("div", {
    role: "none",
    className: "absolute w-full h-full top-0 left-0 -z-1",
    style: {
      backgroundColor: backgroundColorVal,
      opacity: backgroundOpacity
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "inline-flex items-center justify-start flex-1 h-full"
  }, start), /*#__PURE__*/React.createElement("div", {
    className: "truncate flex-3 px-4 text-center H3-Bold",
    style: {
      color: titleColorVal,
      opacity: titleOpacity,
      lineHeight: "".concat(navBarHeight, "px")
    }
  }, center ? center : title), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 inline-flex items-center justify-end h-full"
  }, end), showSeparator && _ref2)), fixed && /*#__PURE__*/React.createElement("div", {
    style: {
      height: navBarHeight
    }
  }));
};

export { TUXNavBar };
//# sourceMappingURL=TUXNavBar.js.map
